export default function ImpressumDatenschutz() {
  return (
    <section className="section">
      <div className="container legal">
        <h2>Impressum</h2>
        <p><strong>Angaben gemäß § 5 TMG und § 55 RStV:</strong></p>
        <p>
          Lydia Zschoche<br />
          Am Berg 4 / Nebengebäude<br />
          84092 Bayerbach b. Ergoldsbach, Ortsteil Greilsberg<br />
          Deutschland
        </p>

        <h3>Kontakt</h3>
        <p>
          Telefon: 0179 4381015<br />
          E-Mail: <a href="mailto:info@stickerei-zschoche.de">info@stickerei-zschoche.de</a>
        </p>

        <h3>Umsatzsteuer-Identifikationsnummer gem. § 27 a UStG</h3>
        <p>DE 250814049</p>

        <h3>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h3>
        <p>Lydia Zschoche (Anschrift wie oben)</p>

        <hr />

        <h3>Haftung für Inhalte</h3>
        <p>
          Die Inhalte dieser Website wurden mit größter Sorgfalt erstellt. Für die Richtigkeit,
          Vollständigkeit und Aktualität der Inhalte kann jedoch keine Gewähr übernommen werden.
          Als Diensteanbieterin bin ich gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten
          verantwortlich.
        </p>
        <p>
          Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den
          allgemeinen Gesetzen bleiben hiervon unberührt.
        </p>

        <h3>Haftung für Links</h3>
        <p>
          Diese Website enthält Links zu externen Webseiten Dritter, auf deren Inhalte kein Einfluss
          besteht. Deshalb kann für diese fremden Inhalte keine Gewähr übernommen werden.
          Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber
          verantwortlich. Zum Zeitpunkt der Verlinkung wurden die Seiten auf mögliche Rechtsverstöße
          überprüft – rechtswidrige Inhalte waren nicht erkennbar.
        </p>

        <h3>Urheberrecht</h3>
        <p>
          Alle auf dieser Website veröffentlichten Inhalte, Bilder, Grafiken und Texte unterliegen
          dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung oder jede Art
          der Verwertung außerhalb der Grenzen des Urheberrechts bedarf der schriftlichen Zustimmung
          der jeweiligen Autorin oder Rechteinhaberin. Downloads und Kopien dieser Seite sind nur
          für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit Inhalte nicht von der
          Betreiberin erstellt wurden, werden die Urheberrechte Dritter beachtet und entsprechend
          gekennzeichnet.
        </p>

        <h3>Bilder und Urheberrecht</h3>
        <p>
          Alle auf dieser Website verwendeten Bilder stammen ausschließlich aus eigenem Besitz bzw.
          wurden selbst erstellt. Eine Nutzung, Vervielfältigung oder Weitergabe der Fotos, Logos oder anderer Inhalte ist ohne ausdrückliche Zustimmung nicht gestattet.
        </p>

        <hr />

        <h2>Datenschutzerklärung</h2>

        <h3>1. Verantwortliche Stelle</h3>
        <p>
          Lydia Zschoche<br />
          Am Berg 4 / Nebengebäude<br />
          84092 Bayerbach b. Ergoldsbach<br />
          E-Mail: <a href="mailto:info@stickerei-zschoche.de">info@stickerei-zschoche.de</a><br />
          Telefon: 0179 4381015
        </p>

        <h3>2. Erhebung und Speicherung personenbezogener Daten</h3>
        <p>
          Beim Besuch dieser Website werden automatisch Informationen durch den Webserver erfasst (Server-Logfiles), darunter:
        </p>
        <ul>
          <li>Besuchte Seite</li>
          <li>Datum und Uhrzeit</li>
          <li>Übertragene Datenmenge</li>
          <li>Browsertyp und -version</li>
          <li>Betriebssystem</li>
          <li>Referrer-URL</li>
          <li>IP-Adresse (anonymisiert)</li>
        </ul>
        <p>
          Die Verarbeitung erfolgt gemäß Art. 6 Abs. 1 lit. f DSGVO auf Basis des berechtigten Interesses an der technischen Sicherheit und Stabilität der Website.
          Eine Weitergabe oder Auswertung zu Marketingzwecken erfolgt nicht.
        </p>

        <h3>3. Cookies</h3>
        <p>
          Diese Website verwendet Cookies, um grundlegende Funktionen bereitzustellen (z. B. Spracheinstellungen oder Navigation).
          Cookies sind kleine Textdateien, die auf Ihrem Gerät gespeichert werden.
          Sie können über den Cookie-Banner entscheiden, welche Cookies gesetzt werden dürfen.
        </p>
        <p>
          Rechtsgrundlage für technisch notwendige Cookies ist Art. 6 Abs. 1 lit. f DSGVO, für optionale Cookies (Analyse usw.) Art. 6 Abs. 1 lit. a DSGVO.
          Eine Einwilligung kann jederzeit über den Cookie-Banner widerrufen werden.
        </p>

        <h3>4. Kontaktaufnahme</h3>
        <p>
          Wenn Sie uns per E-Mail oder Telefon kontaktieren, werden Ihre Angaben zur Bearbeitung der Anfrage verarbeitet (Art. 6 Abs. 1 lit. b DSGVO).
          Die Daten werden gelöscht, sobald der Zweck der Speicherung entfällt.
        </p>

        <h3>5. Rechte der betroffenen Personen</h3>
        <p>
          Sie haben das Recht auf Auskunft (Art. 15 DSGVO), Berichtigung (Art. 16 DSGVO), Löschung (Art. 17 DSGVO), Einschränkung der Verarbeitung (Art. 18 DSGVO),
          Datenübertragbarkeit (Art. 20 DSGVO) und Widerspruch (Art. 21 DSGVO). Bitte richten Sie Ihre Anfragen an die oben genannte Verantwortliche.
        </p>

        <h3>6. Beschwerderecht</h3>
        <p>
          Sie haben das Recht, sich bei einer Aufsichtsbehörde zu beschweren, wenn Sie der Ansicht sind, dass die Verarbeitung Ihrer personenbezogenen Daten
          gegen die DSGVO verstößt. Zuständig ist in Bayern das Bayerische Landesamt für Datenschutzaufsicht (BayLDA).
        </p>

        <h3>7. Streitbeilegung</h3>
        <p>
          Hinweis zur Verbraucherstreitbeilegung gemäß § 36 Verbraucherstreitbeilegungsgesetz (VSBG): <br />
          Ich bin weder verpflichtet noch bereit, an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
        </p>
      </div>
    </section>
  );
}
